import { HTMLAttributes } from 'react'
import * as Portal from '@radix-ui/react-portal'

import Typography from '@/components/base/typography'

import { cn } from '@/lib/utils'

export type MobileBottomBarProps = HTMLAttributes<HTMLElement> &
  Partial<{
    items: {
      link: {
        url: string
        title: string
        target?: string
      }
    }[]
  }>

const MobileBottomBar = ({
  items,
  className,
  ...props
}: MobileBottomBarProps) => {
  return (
    <Portal.Root>
      <footer
        className={cn(
          className,
          'fixed bottom-0 left-0 z-header flex w-full bg-gray-500 pt-[1px] md:hidden'
        )}
        {...props}
      >
        <div className="relative z-header grid w-full grid-cols-2 gap-[1px]">
          {items?.map((item, index: number) => (
            <a
              key={index}
              href={item?.link?.url}
              target={item?.link?.target || '_self'}
              className="flex w-full items-center justify-center bg-[#E5B273] p-[1.8rem] text-center text-black"
              data-gtm-event="book-cta"
            >
              <Typography className="pointer-events-none text-[16px] font-bold uppercase leading-[1.2] tracking-[0.05rem]">
                {item?.link?.title}
              </Typography>
            </a>
          ))}
        </div>
      </footer>
    </Portal.Root>
  )
}

export default MobileBottomBar
